export default "__VITE_ASSET__Cf36M0tS__"